



























































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { Product, ProductsApi } from '../../../../api';
import Toast from '@/components/display/toast.vue';
import SitePicker from '@/components/site-picker.vue';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import { AxiosResponse } from 'axios';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
@Component({
	components: {
		secondaryNav,
		SitePicker,
	},
	validations: {
		form: {
			site: { required },
		},
	},
	mixins: [validationMixin],
})
export default class ProductUpdate extends Vue {
	public form = {
		site: {},
		name: '',
	};

	public product: any = null;
	public $bvToast: any;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { productId } = this.$route.params;
		const product: Product = this.product;
		product.name = this.form.name;
		product.siteId = this.form.site.id;

		let response: AxiosResponse<any>;
		try {
			response = await new ProductsApi().updateProduct(parseInt(productId, 10), { data: product });
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Product not updated ' + e.response.data.message;
			} else if (e.request) {
				error = 'Product not updated, network Error';
			} else {
				error = 'Product not updated, unknown Error';
			}
			new Toast().makeToast(error, 'Error Updating Product', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Product Updated', 'Successfully', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'products.water.view', params: { productId } });
		}, 1000);
	}

	public async load() {
		const { productId } = this.$route.params;
		this.submitStatus = 'OK';
		this.loading = true;

		try {
			const response = await this.api.getProductById(parseInt(productId, 10), {
				params: { include: 'org,site,subscriptionitem' },
			});
			let product = response.data;

			this.form.site = product.site;
			this.form.name = product.name;
			this.product = product;
		} catch (e) {
			this.product = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
